module.exports = __webpack_public_path__ + "img/builder-32.3770c06b.jpg";